import * as R from 'ramda';

import { DataType } from '@atom/types/dataType';
import { WorkOrderDetailType } from '@atom/types/work';

import CustomFieldRow from './CustomFieldRow';
import { getMappedWorkCustomFields, MappedField } from './reportUtilities';

import classes from './workOrderReport.module.css';

interface Props {
  workOrder: WorkOrderDetailType;
}

const WorkCustomFieldsSection = ({ workOrder }: Props) => {
  const mappedWorkCustomFields = getMappedWorkCustomFields(workOrder);

  const isSummary = R.propEq(DataType.SUMMARY, 'dataType');
  const customFieldRows = R.chain(
    R.splitEvery(3),
    R.groupWith(
      (current, next) => isSummary(current) === isSummary(next),
      mappedWorkCustomFields,
    ),
  );

  return (
    <div className={classes.customFieldSection}>
      {customFieldRows.map((fields: MappedField[], index) => (
        <CustomFieldRow key={index} fields={fields} />
      ))}
    </div>
  );
};

export default WorkCustomFieldsSection;
